import {SavedReportsLimitResults} from 'app_api/me/types';
import {savedReportsLimitClient} from 'common/report/queries/app-api/saved-reports-limit-client';

import {Store, Subscription} from './store';

export interface InfiniteSavedReportsLimit {
  hasFiniteLimit: false;
  isBelowLimit: boolean;
}

export interface FiniteSavedReportsLimit {
  hasFiniteLimit: true;
  isBelowLimit: boolean;
  finiteLimit: number;
  savedReportsCount: number;
}

export type SavedReportsLimit = InfiniteSavedReportsLimit | FiniteSavedReportsLimit;

export const savedReportsLimitStore = new Store<Record<number, SavedReportsLimit>>({
  apiClient: savedReportsLimitClient,
  defaultValue: {},
  name: `saved-reports-limit`,
  transform: {
    index: (
      results: SavedReportsLimitResults,
      {subscription}: {subscription: Subscription},
    ): Record<number, SavedReportsLimit> => {
      const limit: SavedReportsLimit = results.has_finite_limit
        ? {
            hasFiniteLimit: true,
            isBelowLimit: results.is_below_limit,
            finiteLimit: results.finite_limit,
            savedReportsCount: results.saved_reports_count,
          }
        : {
            hasFiniteLimit: false,
            isBelowLimit: results.is_below_limit,
          };

      // Note: if the Store value type is a plain object, this transformed return value is applied as a partial update
      return {[subscription.params[`projectId`]]: limit};
    },
  },
});
